<template>
  <div class="signup-card">
    <!-- brand logo -->
    <div class="mt-2 d-flex align-center" style="display: flex; justify-content: center; padding: 15px 0 15px 0;">
      <v-img :src="require('@/assets/logo.png')" max-height="80px" max-width="80px" alt="logo" contain
        class="me-3"></v-img>
    </div>

    <div style="width: 100%; display: flex; justify-content: center;">
      <p class="text-xl font-weight-semibold mt-2">{{ $i18n.t("ppt_add_in_main.login_home_title") }} 👋🏻</p>
    </div>
    <!--/ brand logo -->

    <ToogleBtn v-if="false" class="mx-auto" v-model="loginType" style="margin-top: 10px;"
      :phoneText="$i18n.t('signup.input_placeholer_account_mobile')" :emailText="$i18n.t('signup.input_placeholer_account_email')"
      :defaultActive="'email'"
      @change="handleCustomTabChange"/>
    <!-- signup form -->
    <v-form :disabled="isSending || isRegisting">
      <v-text-field v-model="email" v-show="loginType === 1" outlined
        :label="$i18n.t('signup.input_placeholer_account_email')"
        :placeholder="$i18n.t('signup.input_placeholer_account_email')" :error-messages="errorMessages.email"
        :rules="[validators.emailValidator]" hide-details="auto" style="margin-top: 20px;"></v-text-field>

      <v-text-field v-model="mobile" v-show="loginType === 10" outlined
        :label="$i18n.t('signup.input_placeholer_account_mobile')"
        :placeholder="$i18n.t('signup.input_placeholer_account_mobile')" :error-messages="errorMessages.mobile"
        :rules="[validators.mobileValidator]" hide-details="auto" style="margin-top: 20px;"></v-text-field>

      <div style="display: flex; align-items: center; margin-top: 20px;">
        <v-text-field v-model="vcode" outlined type="text" :label="$i18n.t('signup.input_placeholer_verify_code')"
          :error-messages="errorMessages.vcode" :rules="[]"
          :placeholder="$i18n.t('signup.input_placeholer_verify_code')" hide-details="auto"
          style="max-width: 120px"></v-text-field>
        <div></div>
        <v-btn color="primary" :loading="isSending" :disabled="disableSendCode"
          @keydown.enter.stop="onClickCodeButton" @click="onClickCodeButton" style="max-width: 100px; margin-left: 20px;" outlined>
          {{ codeBtnText }}
        </v-btn>
      </div>

      <v-text-field v-model="password" outlined :type="isPasswordVisible ? 'text' : 'password'"
        :label="$i18n.t('signup.input_placeholder_password')" :error-messages="errorMessages.password" :rules="[]"
        :placeholder="$i18n.t('signup.input_placeholder_password')"
        :append-icon="isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye'" hide-details="auto"
        @click:append="isPasswordVisible = !isPasswordVisible" style="margin-top: 20px;"></v-text-field>

      <v-text-field v-model="rePassword" outlined :type="isRePasswordVisible ? 'text' : 'password'"
        :label="$i18n.t('signup.input_placeholder_repeat_password')" :error-messages="errorMessages.rePassword"
        :rules="[]" :placeholder="$i18n.t('signup.input_placeholder_repeat_password')"
        :append-icon="isRePasswordVisible ? 'mdi-eye-off' : 'mdi-eye'" hide-details="auto"
        @click:append="isRePasswordVisible = !isRePasswordVisible" @keydown.enter="onClickSignupButton" style="margin-top: 20px;"></v-text-field>

      <div  style="display: flex; justify-content: center; align-items: center; flex-direction: column; margin-top: 30px; margin-bottom: 5px;">
        <v-btn class="get-started-btn" width="50%" :loading="isRegisting" @click="onClickSignupButton">
          {{ $i18n.t("signup.txt_btn_signup") }}
        </v-btn>
      </div>
      <div  style="display: flex; justify-content: center; align-items: center; flex-direction: column; margin-bottom: 10px;">
        <v-btn text @click="onLogin"> {{ $i18n.t("signup.txt_btn_go_signin") }} </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
import { i18n } from "@/plugins/i18n";

//例如: import <组件名称> from  <组建路径>
import {
  required,
  emailValidator,
  mobileValidator,
  isEmpty
} from "@/utils/validation.js";
import ToogleBtn from '@/components/toogle_btn.vue';

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {
    ToogleBtn
  },
  props: {
    isSending: {
      type: Boolean,
      required: true,
    },
    isRegisting: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    //这里存放数据
    return {
      isPasswordVisible: false,
      isRePasswordVisible: false,
      email: "",
      mobile: "",
      vcode: "",
      disableSendCode: true,
      codeBtnText: i18n.t("signup.txt_btn_get_verify_code"),
      codeBtnCountSeconds: 60,
      // userName: "",
      password: "",
      rePassword: "",
      loginType: 1,
      errorMessages: {
        email: "",
        mobile: "",
        vcode: "",
        // userName: "",
        password: "",
        rePassword: "",
      },
      validators: {
        required,
        emailValidator,
        mobileValidator,
      }
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {
    email(val) {
      if(this.loginType === 1)
      this.disableSendCode = this.validators.emailValidator(val) == true ? false : true
    },
    mobile(val) {
      if(this.loginType === 10)
      this.disableSendCode = this.validators.mobileValidator(val) == true ? false : true
    }
  },
  methods: {
    onLogin() {
      this.$emit("gotoSignIn");
    },
    reserve() {
      this.loading = true;
      setTimeout(() => (this.loading = false), 2000);
    },
    onClickCodeButton() {
      let accountName;
      if (this.loginType === 10) {
        if (isEmpty(this.mobile)) {
          this.$message.warning(this.$i18n.t("valiad.show_user_msg_account_required"))
          return;
        }
        accountName = this.mobile;
      } else if (this.loginType === 1) {
        if (isEmpty(this.email)) {
          this.$message.warning(this.$i18n.t("valiad.show_user_msg_account_required"))
          return;
        }
        accountName = this.email;
      } else throw "Unsupport login type.";

      this.$emit("sendVerificationCode", {
        accountName: accountName,
        loginType: this.loginType,
      });
    },
    codeSendSuccess() {
      this.disableSendCode = true;
      this.countCodeBtn(this.codeBtnCountSeconds);
    },
    handleCustomTabChange(newTab) {
      // clear input fields
      this.email = "";
      this.mobile = "";

      // this.disableSendCode = false;
      this.loginType = newTab === 'phone' ? 10 : 1;
      console.log("Custom tab changed to:", newTab);
    },
    countCodeBtn(seconds) {
      let that = this;
      if (seconds <= 0) {
        that.disableSendCode = false;
        that.codeBtnText = this.$i18n.t("signup.txt_btn_get_verify_code");
        return;
      }

      that.codeBtnText = seconds--;
      window.setTimeout(function () {
        that.countCodeBtn(seconds);
      }, 1000);
    },
    onClickSignupButton() {
      let accountName;

      if (this.loginType === 10) accountName = this.mobile;
      else if (this.loginType === 1) accountName = this.email;
      else throw "Unsupport login type.";

      this.$emit("signup", {
        accountName: accountName,
        loginType: this.loginType,
        vcode: this.vcode,
        userName: accountName,
        password: this.password,
        rePassword: this.rePassword,
        regionId: 'F0F81BBD-F7F1-4E9B-B3F6-5CF8FE5A4922' //Default US
      });
    },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() { },
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() { },
  destroyed() { }, //生命周期-销毁完成
  activated() { }, //如果页面有keep-alive,这函数会触发
};
</script>

<style scoped>

.signup-card {
  width: 80%;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.get-started-btn {
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
</style>
